import { apiClient, API_CONFIG } from '../../../core';
import type { ApiResponse } from '../../../shared';
import type {
  LC_ListEnrollmentReportIn,
  LC_ListEnrollmentReportOut,
  EnrollmentReportPage,
} from '../types';
import { mapEnrollmentReportPage } from '../mappers';


export class EnrollmentReportService {
  async list(
    params: LC_ListEnrollmentReportIn,
    signal?: AbortSignal,
  ): Promise<ApiResponse<EnrollmentReportPage>> {
    const endpoint = `${API_CONFIG.ENDPOINTS.ATTENDANCE.REPORTS_ENROLLMENT}/search`;

    const response = await apiClient.post<LC_ListEnrollmentReportOut>(endpoint, params, { signal });

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    return { ...response, data: mapEnrollmentReportPage(response.data) };
  }
}

export const enrollmentReportService = new EnrollmentReportService();
